import { ref } from 'vue'

interface Options {
  onScroll?: () => void
}

export const useMobileInertiaScroll = (options: Options = {}) => {
  const {
    onScroll = () => {}
  } = options

  let inertiaFrame = 0
  const isTouching = ref(false)
  const lastTouchY = ref(0)
  const lastTouchTime = ref(0)
  const velocityY = ref(0)

  const stopInertia = () => {
    if (inertiaFrame) cancelAnimationFrame(inertiaFrame)
    inertiaFrame = 0
  }

  const onTouchStart = (e: TouchEvent) => {
    isTouching.value = true
    stopInertia()

    lastTouchY.value = e.touches[0].clientY
    lastTouchTime.value = performance.now()
    velocityY.value = 0
  }

const onTouchMove = (e: TouchEvent, el?: HTMLElement | null) => {
  if (!el) return

  const maxScroll = el.scrollHeight - el.clientHeight
  const currentScroll = el.scrollTop
  const delta = lastTouchY.value - e.touches[0].clientY

  const isScrollingDown = delta > 0
  const isScrollingUp = delta < 0

  const canScrollDown = currentScroll < maxScroll
  const canScrollUp = currentScroll > 0

  // ⭐ 只有容器自己能滚动时才阻止默认
  if (
    (isScrollingDown && canScrollDown) ||
    (isScrollingUp && canScrollUp)
  ) {
    e.preventDefault()
  } else {
    // ⭐ 到边缘了 → 不阻止浏览器默认滚动
    return
  }

  // ----- 原逻辑 -----
  const now = performance.now()
  const deltaTime = now - lastTouchTime.value
  velocityY.value = delta / deltaTime
  el.scrollTop += delta

  lastTouchY.value = e.touches[0].clientY
  lastTouchTime.value = now

  onScroll()
}

  const onTouchEnd = () => {
    isTouching.value = false
    startInertia()
  }

  const startInertia = () => {
    const step = () => {
      if (Math.abs(velocityY.value) < 0.001) {
        stopInertia()
        return
      }

      velocityY.value *= 0.95
      options.element!.scrollTop += velocityY.value * 16

      onScroll()
      inertiaFrame = requestAnimationFrame(step)
    }

    inertiaFrame = requestAnimationFrame(step)
  }

  const attach = (el: HTMLElement) => {
    options.element = el

    el.addEventListener('touchstart', onTouchStart, { passive: true })
    el.addEventListener('touchmove', (e) => onTouchMove(e, el), { passive: false })
    el.addEventListener('touchend', onTouchEnd, { passive: true })
  }

  const detach = (el: HTMLElement) => {
    el.removeEventListener('touchstart', onTouchStart)
    el.removeEventListener('touchmove', (e) => onTouchMove(e, el))
    el.removeEventListener('touchend', onTouchEnd)
  }

  return {
    attach,
    detach,
    stopInertia,
  }
}
